import React, {SyntheticEvent, useState} from "react";
import s from './CourseSection.module.scss';
import CourseSectionHeader from "./CourseSectionHeader/CourseSectionHeader";
import CourseSectionBody from "./CourseSectionBody/CourseSectionBody";
import {ISectionModel} from "../../../models/view/bootCampPage/IBootCampPageModel";
import ICard from "../../../models/view/common/ICard";
import CourseSectionViewState from "./CourseSectionViewState";

interface ICourseSectionProps {
  courseId: number,
  sectionNumber: number,
  sectionModel: ISectionModel,
  onCardClick?: (card: ICard) => void,
  quantityOfNewSongs: number;
  sectionId: number
}

export default function CourseSection({courseId, sectionNumber, sectionModel, onCardClick, quantityOfNewSongs, sectionId}: ICourseSectionProps) {
  const courseSectionViewState = new CourseSectionViewState(courseId, sectionNumber);
  const [isOpen, setIsOpen] = useState(courseSectionViewState.isSectionOpen());

  function onDetailsToggle(e: SyntheticEvent<HTMLDetailsElement, Event>): void {
    courseSectionViewState.onSectionStateChange(e.currentTarget.open);
    setIsOpen(e.currentTarget.open);
  }

  return (
    <details className={s.courseSection} open={isOpen} onToggle={onDetailsToggle}>
      <CourseSectionHeader sectionNumber={sectionNumber} sectionModel={sectionModel} showDetails={isOpen} />
      <CourseSectionBody cards={sectionModel.cards} cardClicked={onCardClick} quantityOfNewSongs={quantityOfNewSongs} sectionId={sectionId} />
    </details>
  );
}

